// extracted by mini-css-extract-plugin
export var downArrow = "_9e-0";
export var label = "_9e-1";
export var treatmentCard = "_9e-3";
export var upArrow = "_9e-2";